import axiosInstance from './api'
import TokenService from '@/services/auth/token.service'

const setup = () => {
    axiosInstance.interceptors.request.use(
        (config) => {
            const token = TokenService.getLocalAccessToken()
            if (token){
                config.headers['Authorization'] = `Bearer ${token}`
            }
            return config
        },
        (error) => {
            return Promise.reject(error)
        }
    );

    axiosInstance.interceptors.response.use(
        (res)   => {
            return res;
        },
        async (err) => {
            const originalConfig = err.config

            if (originalConfig.url !== "/login"  && err.response){
                //access token was expired
                //todo refactor store.dispatch('auth/logout')
                if (err.response.status === 401 && !originalConfig._retry){
                    originalConfig._retry = true

                    try {
                        //todo handle expired tokens
                        // const rs = await axiosInstance.post("/oatuh/refresh", {
                        //     refreshToken: TokenService.getLocalRefreshToken()
                        // })
                        //
                        // const { accessToken } = rs.data
                        // store.dispatch('auth/refreshToken',accessToken)
                        // TokenService.updateLocalAccessToken(accessToken)
                        // this.$store.dispatch('auth/logout')

                        //todo jedy
                        // await router.push('/login')
                        document.location = '/login'
                        return axiosInstance(originalConfig)
                    }catch (_error){
                        return Promise.reject(_error)
                    }
                }
            }
            return  Promise.reject(err)
        }
    )
}

export default setup;